// extracted by mini-css-extract-plugin
export var carrierNotice = "_l9-5";
export var carrierNoticePlaceholder = "_l9-6";
export var deliveryRow = "_l9-c";
export var fixedHeight = "_l9-4";
export var freightLogo = "_l9-b";
export var fullWidth = "_l9-3";
export var priceColumn = "_l9-7";
export var radioSelected = "_l9-9";
export var radioUnselected = "_l9-8";
export var selectedOption = "_l9-2";
export var selectedOptionContainer = "_l9-1";
export var selection = "_l9-0";
export var tallSkeletonText = "_l9-a";